import React from "react";

const Save = ({ className, title = "", fill = "#6D7881", onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="Asset-Artboard-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icons/merge-04-|-🛠-|-Icons/Functional/save02" fill={fill}>
          <path
            d="M16.3029437,2.4 L3.6,2.4 C2.9372583,2.4 2.4,2.9372583 2.4,3.6 L2.4,20.4 C2.4,21.0627417 2.9372583,21.6 3.6,21.6 L20.4,21.6 C21.0627417,21.6 21.6,21.0627417 21.6,20.4 L21.6,7.69705627 L16.3029437,2.4 Z M16.8,0 C17.1182598,0 17.4234845,0.126428208 17.6485281,0.351471863 L23.6485281,6.35147186 C23.8735718,6.57651552 24,6.88174021 24,7.2 L24,20.4 C24,22.3882251 22.3882251,24 20.4,24 L3.6,24 C1.6117749,24 0,22.3882251 0,20.4 L0,3.6 C0,1.6117749 1.6117749,0 3.6,0 L16.8,0 Z M18,12 L6,12 C5.3372583,12 4.8,12.5372583 4.8,13.2 L4.8,13.2 L4.8,21.5987 L7.2,21.5987 L7.2,14.4 L16.8,14.4 L16.8,21.5987 L19.2,21.5987 L19.2,13.2 C19.2,12.5372583 18.6627417,12 18,12 L18,12 Z M7.2,2.4 L4.8,2.4 L4.8,7.2 C4.8,7.8627417 5.3372583,8.4 6,8.4 L6,8.4 L15.6,8.4 C16.2627417,8.4 16.8,7.8627417 16.8,7.2 C16.8,6.5372583 16.2627417,6 15.6,6 L15.6,6 L7.2,6 L7.2,2.4 Z"
            id="ic-save"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Save;
